import React from "react";
import { CORNER_RADIUS } from "../styles/Sizes";
import { styled, ThemeProvider } from "@mui/material/styles";
import { Box, Grid, Typography, createTheme } from "@mui/material";
import { WHITE_FFF, BLUE_2640, GREY_4C4D } from "../styles/Colors";

const boxStyle = {
	backgroundColor: WHITE_FFF,
	height: "75px",
	width: "163px",
	borderRadius: CORNER_RADIUS,
	justifyContent: "center",
	direction: "row",
	alignItems: "center",
	paddingBottom: "5px",
	paddingTop: "5px",
};
const Img = styled("img")({
	maxWidth: "30px",
	maxHeight: "30px",
	width: "fit-content",
	height: "fit-content",
	paddingTop: "4px",
	paddingRight: "4px",
});

function CurrencyBox(props: any) {
	const theme = createTheme();
	theme.typography.body1 = {
		color: BLUE_2640,
		fontSize: "16px",
		fontFamily: "Avenir",
	};

	theme.typography.body2 = {
		color: GREY_4C4D,
		fontSize: "12px",
		fontFamily: "Avenir",
	};

	return (
		<Box display="flex" justifyContent="center" alignItems="center" textAlign="right">
			<Grid container sx={boxStyle} wrap="nowrap">
				<Grid item sx={{pr: '15px' }}>{props.flag && <Img src={props.flag} />}</Grid>
				<Grid item>
					<Box
						sx={{
							paddingLeft: "7px",
							paddingRight: "7px",
						}}
					>
						<ThemeProvider theme={theme}>
							<Typography variant="body1" fontWeight="900">
								{props.pair}
							</Typography>
							<Typography variant="body2">{props.price}</Typography>
						</ThemeProvider>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
}

export default CurrencyBox;
